import { defineComponent, ref } from 'vue';
import header_462 from '../../images/header_small_462.png';
import header_750 from '../../images/header_small_750.png';
import header_942 from '../../images/header_small_942.png';
import header_1202 from '../../images/header_small_1202.png';
import header_1910 from '../../images/header_small_1910.png';
import header_2550 from '../../images/header_small_2550.png';

export default defineComponent({
    props: {
        title: String
    },
    setup: function (props, ctx) {

        const getStyle = function (img: any) {
            return 'url(' + img + ') no-repeat top center #68b6e7';
        }

        const headerStyles = ref({
            '--bg_462': getStyle(header_462),
            '--bg_750': getStyle(header_750),
            '--bg_942': getStyle(header_942),
            '--bg_1202': getStyle(header_1202),
            '--bg_1910': getStyle(header_1910),
            '--bg_2550': getStyle(header_2550)
        });

        return {
            headerStyles
        };
    }
});
